<template>
  <div>
      <div class="center-content">
            <!-- 顶部的banner -->
            <div class="center-banner"></div>
            <!-- 搜索框 -->
            <div class="center-search">
                <!-- 选择查询类型 -->
                <!-- <div class="select-type">
                    <div data-type="1">
                        <i class="c-icon c-icon-dci"></i>
                        <span>证书编号</span>
                    </div>
                    <div data-type="2">
                        <i class="c-icon c-icon-name"></i>
                        <span>作品名称</span>
                    </div>
                    <div data-type="3">
                        <i class="c-icon c-icon-owner"></i>
                        <span>著作权人</span>
                    </div>
                </div> -->
                <div class="select-input">
                    <div class="c-icon-search"></div>
                    <input type="text" v-model="searchValue" placeholder="请输入作品名称或证书编号">
                    <div class="c-icon-button" @click="searchCertificate"></div>
                </div>
            </div>
            <div
      v-if="searchResultVisible"
      class="container resultView"
    >
      <!-- 证书搜索 -->
      <template v-if="resultType==1">
        <div class="commonTitle"> 搜索结果 </div>
        <div @click="resultType=2">查看上链信息</div>
        <div class="imgWrap">
          <el-image
            :src="certificateImg"
            :preview-src-list="[certificateImg]"
          >
          </el-image>
        </div>
      </template>

      <!-- hash搜索-->
      <template v-if="resultType==2">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>中国知链</el-breadcrumb-item>
          <el-breadcrumb-item>区块链详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="commonWhiteBg HashResult">
          <div class="commonTitle"> 区块链详情 </div>
          <table class="detailTable">
            <tr>
              <td class="label"> 公示hash </td>
              <td class="value"> {{transactionInfo.transactionData.hash}} </td>
            </tr>
            <tr>
              <td class="label"> 公示时间 </td>
              <td class="value"> {{transactionInfo.transactionData.timeText}} </td>
            </tr>
            <tr>
              <td class="label"> 交易类型 </td>
              <td class="value"> {{transactionInfo.transactionData.txType}} </td>
            </tr>
            <tr>
              <td class="label"> 区块高度 </td>
              <td class="value"> {{transactionInfo.blockNumber}} </td>
            </tr>
            <tr>
              <td class="label"> 区块hash </td>
              <td class="value"> {{transactionInfo.blockData.blockHash}} </td>
            </tr>
            <tr>
              <td class="label"> Nonce </td>
              <td class="value"> {{transactionInfo.transactionData.nonce}} </td>
            </tr>
            <tr>
              <td class="label"> 发起账户 </td>
              <td class="value"> {{transactionInfo.transactionData.from}} </td>
            </tr>
            <tr>
              <td class="label"> 目标账户 </td>
              <td class="value"> {{transactionInfo.transactionData.to}} </td>
            </tr>
            <tr>
              <td class="label"> 交易金额 </td>
              <td class="value"> {{transactionInfo.transactionData.value}} </td>
            </tr>
            <tr>
              <td class="label"> 证书 </td>
              <td class="value" @click="resultType=1"> 查看 </td>
            </tr>
            <!-- <tr>
              <td class="label"> 签名 </td>
              <td class="value">
                 <el-popover
                  placement="right"
                    width="400"
                  trigger="click"
                >
                    <el-table
                    width="100%"
                    :data="gridData"
                  >
                    <el-table-column
                      property="code"
                      label="签名"
                    ></el-table-column>
                  </el-table>
                  <a slot="reference">详情</a>
                </el-popover>
              </td>
            </tr>
            <tr>
              <td class="label"> 交易收据 </td>
              <td class="value">
                <el-popover
                  placement="right"
                    width="400"
                  trigger="click"
                >
                  <el-table
                    width="100%"
                    :data="gridData2"
                  >
                    <el-table-column
                      property="result"
                      label="result"
                    ></el-table-column>
                    <el-table-column
                      property="data"
                      label="data"
                    ></el-table-column>
                    <el-table-column
                      property="gasUsed"
                      label="gasUsed"
                    ></el-table-column>
                    <el-table-column
                      property="log"
                      label="log"
                    ></el-table-column>
                  </el-table>
                  <a slot="reference">详情</a>
                </el-popover>
              </td>
            </tr>
            <tr>
              <td class="label"> 交易金额 </td>
              <td class="value"> 0 </td>
            </tr> -->
          </table>
        </div>
      </template>
    </div>
            <!-- 内容信息 -->
            <div class="cc-wrap">
                <div>
                    <!-- 问题标题 -->
                    <div class="question-title">
                        <h1 style="text-align: center; padding-bottom: 50px;" class="cc-warp-title"><span>常见问题</span></h1>
                    </div>
                    <!-- 问题内容信息 -->
                    <div class="question-content container">
                        <ul class="question-list">
                            <li>
                                <div>
                                    <div class="d-img-cert"></div>
                                    <h2>我该如何查询我的数字作品版权证书？</h2>
                                    <p>若您已经获得数字作品版权证书，您可以选择以作品名称或者证书编号来检索关键词，点击立即查询即可检索到相应结果。</p>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <div class="d-img-sign"></div>
                                    <h2>我该如何查看数字证书上的数字签章信息？</h2>
                                    <p>下载PDF专用阅读器，打开您的数字作品版权证书（PDF文件），点击右下角印章处，点击签名属性，即可查看电子签章的发证方信息。</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import { queryCertificateByHash,queryCertificate,queryRegisterList } from '@/api/CertificateService'
export default {
  name: "CheckCenter",

  data() {
    return {
        searchResultVisible: false,
      resultType: 2,
      gridData: [{
        code: 'f5869b5adc0e366b5ae65a8d5ec546da42b14acb46b892161a6543d594306e21'
      }],
      gridData2: [{
        result: '正常',
        data: '',
        gasUsed: '26110',
        log: ''
      }],
      certificateImg: 'https://dbk-read.oss-cn-hangzhou.aliyuncs.com/1/1/2021/01/29/read/system/evidence/certificate/img/2/16777236/900-8324242-571389.jpg',
      certificateInfo:null,
      transactionInfo:null,
      searchValue: this.$route.params.transactionHash||'',
    };
  },

  methods: {
      searchCertificate(){
      let that=this;
        if(this.searchValue.indexOf('-')>-1){
          //根据证书编号查询证书
          queryCertificate(this.searchValue).then(({data})=>{
              console.log(data);
              that.resultType="1";
              that.searchResultVisible=true;
              that.certificateImg=data.certificateInfo.jpgUrl;

               that.certificateInfo=data;
             that.transactionInfo=data.transactionInfo
             
             that.transactionInfo.transactionData.timeText=that.dayjs(that.transactionInfo.transactionData.timestamp).format('YYYY-MM-DD HH:mm:ss');

          });
        }else{
          //根据hash查询证书
           queryCertificateByHash(this.searchValue).then(({data})=>{
             console.log(data);
             that.resultType="2";
             that.certificateImg=data.certificateInfo.jpgUrl;

             that.certificateInfo=data;
             that.transactionInfo=data.transactionInfo
             
             that.transactionInfo.transactionData.timeText=that.dayjs(that.transactionInfo.transactionData.timestamp).format('YYYY-MM-DD HH:mm:ss');
             that.searchResultVisible=true;
          });
        }
    },

    // 搜索证书
    // searchCertificate(){
    //   if(this.searchValue!=''){
    //     this.searchResultVisible = true;
    //   }else{
    //     this.searchResultVisible = false;
    //   }
    //   let params = {
    //     status: "21",
    //     keywords: this.searchValue,
    //   }
    //   queryRegisterList(this.pagination.page,this.pagination.pageSize,params).then(({data}) => {
		// 		console.log("搜索登记列表",data.list);
    //     for (let i = 0; i < data.list.length; i++) {
    //       data.list[i].createTimeText= this.dayjs(data.list[i].createTime*1000).format('YYYY-MM-DD HH:mm:ss ');
    //     }
    //     that.certificateImg=data.certificateInfo.jpgUrl;
    //     that.certificateInfo=data;
    //     that.transactionInfo=data.transactionInfo
        
    //     that.transactionInfo.transactionData.timeText=that.dayjs(that.transactionInfo.transactionData.timestamp).format('YYYY-MM-DD HH:mm:ss');
    //     that.searchResultVisible=true;
		// 	})
    // },

  },
  
};
</script>

<style lang="scss" scoped>
.HashResult {
  padding: 34px 36px;
  .commonTitle {
    font-size: 16px;
  }
  .detailTable {
    width: 100%;
    tr {
      border-bottom: solid 1px #eee;
      td {
        padding: 16px;
        vertical-align: top;
      }
      .label {
        width: 25%;
        color: rgba(0, 18, 22, 0.5);
      }
      .value {
        color: rgba(0, 18, 22, 1);
        white-space: normal;
        word-break: break-all;
      }
    }
  }
}
.resultView {
  margin: 132px auto 32px auto;
  .imgWrap {
    display: flex;
    justify-content: center;
    /deep/ .el-image {
      width: 80%;
      max-width: 595px;
    }
  }
}
.center-banner {
    height: 374px;
    background: url(../assets/images/center-banner.jpg) top center;
}
.center-search {
    width: 990px;
    margin: -30px auto 0;
}
.select-type {
    float: left;
    padding: 0;
    margin: 0;
    background-color: #fff;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    border-radius: 4px;
    border: 1px solid #b8e0ff;
    width: 186px;
    height: 58px;
    overflow: hidden;
    transition: .5s;
}
.select-type > div {
    height: 58px;
    line-height: 58px;
    padding-left: 32px;
    cursor: pointer;
    border-top: 1px solid #b8e0ff;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none;
}
.select-type > div:first-child {
    border-top: 0;
}
.c-icon {
    width: 17px;
    height: 21px;
    display: inline-block;
    vertical-align: middle;
    background: url(../assets/images/c_icon.png) no-repeat;
}
.c-icon-dci {
    background-position: 0 -42px;
}
.select-type > div span {
    vertical-align: middle;
    margin-left: 10px;
    color: #666;
    font-size: 16px;
    line-height: 29px;
}
.c-icon-name {
    background-position: 0 -21px;
}
.c-icon-owner {
    background-position: 0 0;
}
.select-input {
    position: relative;
    // float: right;
    width: 790px;
    margin: 0 auto;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
    border: 1px solid #b8e0ff;
    overflow: hidden;
    background: #fff;
    display: flex;
    justify-content: space-between;
}
.c-icon-search {
    position: absolute;
    width: 20px;
    height: 20px;
    left: 10px;
    top: 18px;
    background: url(../assets/images/c_icon_search.png) no-repeat;
}
.select-input input {
    display: block;
    width: 575px;
    height: 58px;
    padding-left: 40px;
    padding-right: 40px;
    border: 0;
    outline: none;
}
.c-icon-button {
    position: absolute;
    top: 0;
    right: 0;
    width: 168px;
    height: 58px;
    background: url(../assets/images/c_icon_btn.png) no-repeat;
    background-size: cover;
    margin-right: -1px;
    margin-top: -1px;
    cursor: pointer;
}
.question-title {
    margin: 100px auto 0;
    width: 354px;
    height: 44px;
}
.question-content {
    width: 1160px;
    margin: 40px auto;
    overflow: hidden;
    
}
.question-content ul{
  display: flex;
    justify-content: space-between;
    align-items: center;
}
.question-list > li {
    float: left;
    width: 516px;
    margin-left: 38px;
}
.question-list > li:first-child {
    margin-left: 0;
}
.question-list > li > div {
    border: 1px solid #88bafe;
}
.question-list .d-img-cert, .question-list .d-img-sign {
    display: block;
    width: 476px;
    height: 153px;
}
.question-list .d-img-cert {
  width: 100%;
    background: url(../assets/images/d_img_cert.png) no-repeat;
    background-size: cover;
}
.question-list > li h2 {
    font-size: 16px;
    margin-left: 20px;
    margin-top: 20px;
    font-weight: 500;
}
.question-list > li p {
    margin-top: 15px;
    margin-left: 20px;
    margin-right: 20px;
    height: 80px;
    font-size: 12px;
    letter-spacing: 1px;
}
.question-list .d-img-sign {
  width: 100%;
    background: url(../assets/images/d_img_sign.png) no-repeat;
    background-size: cover;
}
.cc-warp-title{
    font-size: 24px;
    line-height: 32px;
    font-weight: 500;
    color: rgba(3, 3, 3, 0.85);
}
.cc-warp-title span {
    border-bottom: 2px solid #3377fe;
    padding: 6px;
}


@media screen and (max-width: 991px) {
  .center-banner{background-size: 800px;background-repeat: no-repeat;height: 174px;}
  .center-search{display: none;}
  .question-title{margin: 40px auto 0;}
  .question-content{width: 100%;}
  .question-content ul{display: block;}
  .question-list > li{width: 100%;float: none;margin-left: 0;margin-bottom: 10px;}
}

</style>